import { useEffect } from 'react';

/**
 * Sets the tab title (and optionally the meta description / noindex) for a page and
 * restores the previous values on leave. Titles follow "Sección · Violeta" and stay
 * low-key on purpose: tab titles and history can be seen on a shared phone.
 */
export function usePageMeta(title: string, description?: string, noindex = false): void {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;

    const descriptionTag = document.querySelector('meta[name="description"]');
    const previousDescription = descriptionTag?.getAttribute('content') ?? null;
    if (description && descriptionTag) descriptionTag.setAttribute('content', description);

    let robots: HTMLMetaElement | null = null;
    if (noindex) {
      robots = document.createElement('meta');
      robots.name = 'robots';
      robots.content = 'noindex, nofollow';
      document.head.appendChild(robots);
    }

    return () => {
      document.title = previousTitle;
      if (descriptionTag && previousDescription !== null) {
        descriptionTag.setAttribute('content', previousDescription);
      }
      if (robots) document.head.removeChild(robots);
    };
  }, [title, description, noindex]);
}
